/**
 * @generated SignedSource<<8060d1ba1fa8af2ed69ad7d2735bde4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type AppGameClosedSubscription$variables = {};
export type AppGameClosedSubscription$data = {
  readonly sGameClosed: any | null;
};
export type AppGameClosedSubscription = {
  variables: AppGameClosedSubscription$variables;
  response: AppGameClosedSubscription$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sGameClosed",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppGameClosedSubscription",
    "selections": (v0/*: any*/),
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppGameClosedSubscription",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "49e91f915d72f78392263ca263bd8e4a",
    "id": null,
    "metadata": {},
    "name": "AppGameClosedSubscription",
    "operationKind": "subscription",
    "text": "subscription AppGameClosedSubscription {\n  sGameClosed\n}\n"
  }
};
})();

(node as any).hash = "5f8a591e4a041cedd647bc74f14cc47c";

export default node;
